import React from 'react';

import {DisplayInfo} from 'molbio/components/visualizations/SequenceVisualizationConstants';
import {getEnzyme} from 'molbio/enzymes/EnzymeUtil';
import {NEAR_BLACK} from 'ui-library/Colors';
import Line from 'ui-library/svg/Line';
import {Point} from 'util/geometry/GeometryConstants';

import {TextPointInfo} from './SequenceVisualizationConstants';

const MAX_BASE_LENGTH = 10;

function ellipsizeBases(bases: string): string {
  if (bases.length <= MAX_BASE_LENGTH) {
    return bases;
  }
  const numBasesOnEitherSide = MAX_BASE_LENGTH / 2 - 1;
  return `${bases.slice(0, numBasesOnEitherSide)}..${bases.slice(-numBasesOnEitherSide)}`;
}

export function getDisplayInfoText(displayInfo: DisplayInfo): string | null {
  if (displayInfo.enzymeId) {
    return getEnzyme(displayInfo.enzymeId).name;
  } else if (displayInfo.bases) {
    return ellipsizeBases(displayInfo.bases);
  } else {
    return null;
  }
}

function TextLabel({
  sequencePoint,
  textPointInfo,
  text,
}: {
  sequencePoint: Point;
  textPointInfo: TextPointInfo;
  text: string;
}): JSX.Element {
  const textPoint = textPointInfo.point;
  return (
    <>
      <Line startPoint={sequencePoint} endPoint={textPointInfo.point} stroke={NEAR_BLACK} strokeWidth={1} />
      <text
        textAnchor={textPointInfo.anchor}
        x={textPoint.x}
        y={textPoint.y}
        dominantBaseline="middle"
        fontSize="11px"
      >
        {text}
      </text>
    </>
  );
}

export interface DisplayInfoLabelProps {
  sequencePoint: Point;
  textPointInfo: TextPointInfo;
  displayInfo: DisplayInfo;
}

export default function DisplayInfoLabel({
  sequencePoint,
  textPointInfo,
  displayInfo,
}: DisplayInfoLabelProps): JSX.Element | null {
  const text = getDisplayInfoText(displayInfo);
  if (!text) {
    return null;
  }
  return <TextLabel sequencePoint={sequencePoint} textPointInfo={textPointInfo} text={text} />;
}
